module.exports = __webpack_public_path__ + "static/media/Bonfireinstalled.ec446508.webp";